import React from "react";

type BaseNavigationItem = {
  name: string;
  /**
   * icon will only be rendered in mobile navigation
   */
  icon?: React.ReactNode;
};

type SubItemNavigationItem = {
  name: string;
  description?: string;
  icon?: React.ReactNode;
  href: string;
  isServerNavigation?: boolean;
};

export type RootNavigationItem = BaseNavigationItem & {
  href: string;
  isServerNavigation?: boolean;
};

export type NavigationItemWithSubItems = BaseNavigationItem & {
  subItems: SubItemNavigationItem[];
};

export type NavigationItem = RootNavigationItem | NavigationItemWithSubItems;

export const navigation: NavigationItem[] = [
  {
    name: "Beranda",
    href: "/",
  },
  {
    name: "Tentang",
    subItems: [
      {
        name: "Visi & Misi",
        href: "/tentang/visi-misi",
      },
      {
        name: "Profil DHI",
        href: "/tentang/profil",
      },
      {
        name: "Struktur Organisasi",
        href: "/tentang/struktur-organisasi",
      },
      {
        name: "Perencanaan Administrasi",
        href: "/tentang/renmin",
      },
      {
        name: "Protokol",
        href: "/tentang/protokol",
      },
      {
        name: "ATPOL & STP",
        href: "/tentang/atpol-stp",
      },
      {
        name: "Profil Kepolisian Negara-Negara",
        href: "/tentang/profil-kepolisian-internasional",
      },
      {
        name: "Organisasi Internasional",
        href: "/tentang/organisasi-internasional",
      },
      {
        name: "UU & Hukum",
        href: "/tentang/uu-hukum",
      },
    ],
  },
  {
    name: "NCB Interpol",
    subItems: [
      {
        name: "Profil NCB Interpol",
        href: "/profil-ncb",
      },
      {
        name: "Operasi Interpol",
        href: "/operasi-interpol",
      },
      {
        name: "BTNCLO",
        href: "/btnclo",
      },
      {
        name: "Tim Koordinasi Interpol",
        href: "/tim-koordinasi",
      },
      {
        name: "Job Vacancy",
        href: "/job-vacancy",
      },
    ],
  },
  {
    name: "Misi Internasional",
    subItems: [
      {
        name: "Profil Biro Misi Internasional",
        href: "/misi-internasional/profil",
      },
      {
        name: "FPU",
        href: "/misi-internasional/fpu",
      },
      {
        name: "IPO",
        href: "/misi-internasional/ipo",
      },
      {
        name: "Misi Kemanusiaan",
        href: "/misi-internasional/misi-kemanusiaan",
      },
      {
        name: "UN Capacity Building",
        href: "/misi-internasional/un-capacity-building",
      },
    ],
  },
  {
    name: "Kerja Sama Internasional",
    subItems: [
      {
        name: "Profil Biro Kerja Sama Internasional",
        href: "/kerja-sama-internasional/profil",
      },
      {
        name: "MLA",
        href: "/kerja-sama-internasional/mla",
      },
      {
        name: "Perjanjian Internasional",
        href: "/kerja-sama-internasional/perjanjian-internasional",
      },
      {
        name: "Konferensi Internasional",
        href: "/kerja-sama-internasional/konferensi-internasional",
      },
    ],
  },
  {
    name: "Berita",
    href: "/berita",
  },
  {
    name: "Kontak",
    href: "/kontak",
  },
];
